<template>
	<div class="pincode-page">
		<Device>
			<div class="pincode-page__body">
				<img
					:src="require('@images/infoboard_logo.svg')"
					alt="logo"
					class="pincode-page__logo"
				>

				<h3 class="pincode-page__title">
					{{ $t('sharedTexts.pincodeLabel') }}:
				</h3>
				<PinCode
					ref="pincode"
					:number-of-fields="6"
					@pincode="pincode"
				/>
                <small class="g-text--s g-container g-container--no-border">{{ $t('sharedTexts.pincodeText') }}</small>
			</div>
		</Device>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { swapPincode } from '@libs/requests'
import { storage } from '@libs/utils'
import PinCode from '@/components/PinCode.vue'
import Device from '@/components/Device.vue'

export default defineComponent({
	name: 'PincodePage',
	components: {
		PinCode,
		Device
	},
	data() {
		return {
			pinError: false
		}
	},
	setup() {
		const route = useRoute()
		const router = useRouter()
		return { route, router }
	},
	async created() {
		const pinInUrl = this.route.query.pincode as string

		if (pinInUrl) {
			this.pincode('complete', pinInUrl)
		} else {
			// Check for existing authorization using unified storage
			const token = storage.get<string>('authorization')

			if (token) this.router.push('/infoboard')
		}
	},
	methods: {
		async pincode(type: string, pin: string) {
			if (type === 'complete') {
				const response = await swapPincode(pin)

				if (!response.success) {
					const pincodeComponent = this.$refs.pincode as typeof PinCode
					pincodeComponent.showError()
					return
				}

				// Get old PIN using unified storage
				const oldPin = storage.get<string>('current_pin')
				
				// If the PIN has changed, clear cached data
				if (oldPin && oldPin !== pin) {
					storage.clear(['infoboard_cache', 'rotations_cache'])
				}

				// Save new authorization and PIN using unified storage
				storage.set('authorization', response.data as string, true) // 1 year expiration
				storage.set('current_pin', pin, true) // 1 year expiration
				
				this.router.push('/infoboard')
			}
		}
	}
})
</script>

<style lang="scss">
	.pincode-page {
		.pincode {
			margin-top: 10px;
		}
		&__logo {
			display: block;
			width: 68%;
			margin: 0 auto 5px;
		}
		&__body {
			display: flex;
			text-align: center;
			flex-direction: column;
			justify-content: center;
			height: 100%;
			background-color: #e8e8e8;
			background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='32' viewBox='0 0 16 32'%3E%3Cg fill='%23a8a8a8' fill-opacity='0.16'%3E%3Cpath fill-rule='evenodd' d='M0 24h4v2H0v-2zm0 4h6v2H0v-2zm0-8h2v2H0v-2zM0 0h4v2H0V0zm0 4h2v2H0V4zm16 20h-6v2h6v-2zm0 4H8v2h8v-2zm0-8h-4v2h4v-2zm0-20h-6v2h6V0zm0 4h-4v2h4V4zm-2 12h2v2h-2v-2zm0-8h2v2h-2V8zM2 8h10v2H2V8zm0 8h10v2H2v-2zm-2-4h14v2H0v-2zm4-8h6v2H4V4zm0 16h6v2H4v-2zM6 0h2v2H6V0zm0 24h2v2H6v-2z'/%3E%3C/g%3E%3C/svg%3E");
		}
		&__title {
			margin-top: 20px;
			margin-bottom: 10px;
			font-size: 20px;
		}
	}
</style>
